module.exports = __webpack_public_path__ + "static/obenrechts-815e9e5d59226e43d21f549d2c07624f.jpg";